"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZendeskHelpCenterErrorCode = exports.ZendeskDisclaimer = void 0;
var ZendeskDisclaimer;
(function (ZendeskDisclaimer) {
    ZendeskDisclaimer["Bitcoin"] = "BITCOIN";
    ZendeskDisclaimer["BitGo"] = "BITGO";
})(ZendeskDisclaimer || (exports.ZendeskDisclaimer = ZendeskDisclaimer = {}));
var ZendeskHelpCenterErrorCode;
(function (ZendeskHelpCenterErrorCode) {
    ZendeskHelpCenterErrorCode["FetchFailed"] = "ZENDESK_HELP_CENTER_FETCH_FAILED";
    ZendeskHelpCenterErrorCode["LabelSearchFailed"] = "ZENDESK_LABEL_SEARCH_FAILED";
    ZendeskHelpCenterErrorCode["TextSearchFailed"] = "ZENDESK_TEXT_SEARCH_FAILED";
})(ZendeskHelpCenterErrorCode || (exports.ZendeskHelpCenterErrorCode = ZendeskHelpCenterErrorCode = {}));
